import { styled } from '@mui/material/styles';

export const LegalContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
}));
